import { Avatar, Box, Button, Card, CardMedia, Grid, IconButton, Link, Stack, Tab, Tabs, Typography } from '@mui/material'

import { useField } from 'formik'
import React, { useState, useRef } from 'react'
import DatePicker from '../../DatePicker/DatePicker'
import toast from 'react-hot-toast'

export function CopyButton({ ...props }) {
    const { value } = props
    const textAreaRef = useRef(null);

    //const [field, meta, helpers] = useField(props)
    //const { onChange, ...restField } = field


    const copyToClipboard = (e: any) => {
      {/* @ts-ignore */}
      textAreaRef.current.select();
      document.execCommand('copy');
      e.target.focus();
      toast.success(`Copied to clipboard!`);
    };

    return (
      <>
        <Button onClick={copyToClipboard} { ...props }>
          { props.text ? props.text : 'Copy URL' }
        </Button>
        <textarea ref={textAreaRef} style={{ width: '1px', height: '1px' }}>
          { value }
        </textarea>
      </>
    )
}
